export default __webpack_public_path__ + "static/media/3063.ad180fc0.jpg";